export default __webpack_public_path__ + "resources/images/waypoint-soft.png";